import { render, staticRenderFns } from "./VCardWrapper.vue?vue&type=template&id=ffcd5606"
import script from "./VCardWrapper.vue?vue&type=script&lang=js"
export * from "./VCardWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports